














































































import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import BusinessRulesModule from "@/store/modules/business-rules";
import { FacilityList } from "@/models";
import { BusinessRulesState } from "@/models/business-rules/BusinessRulesState";
import { CreateGroupPayload } from "@/models/business-rules/CreateGroupPayload";
import { createGroupText, nameGroupText, nameRulesText } from "@/helpers/business-rules/business-rules-text";

const businessRules = namespace(BusinessRulesModule.name);

@Component({
  name: "CreateGroupAndRule"
})

export default class CreateGroupAndRule extends Vue {
  // ===== Props ===== //
  @Prop(String) private readonly flow?: string;

  // ===== Store ===== //
  @State("businessRules") private readonly businessRules!: BusinessRulesState;
  @businessRules.Action("createGroup") public createGroup!: (payload: CreateGroupPayload) => void;
  @businessRules.Action("createNewCondition") public createNewCondition!: () => void;
  @businessRules.Action("handleCurrentStep") public handleCurrentStep!: (step: number) => void;
  @businessRules.Action("handleGroupDescription") public handleGroupDescription!: (description: string) => void;
  @businessRules.Action("handleGroupName") public handleGroupName!: (groupName: string) => void;
  @businessRules.Action("handleResetCreateGroup") public handleResetCreateGroup!: () => void;
  @businessRules.Action("handleRuleName") public handleRuleName!: (ruleName: string) => void;
  @businessRules.Action("handleSelectedFacilities") public handleSelectedFacilities!: (facilities: FacilityList[]) => void;
  @businessRules.Action("handleResetBusinessRules") public handleResetBusinessRules!: () => void;

  // ===== Data ===== //
  public createGroupText = createGroupText;
  public nameGroupText = nameGroupText;
  public nameRulesText = nameRulesText;
  public nextLoading = false;

  // ===== Methods ===== //
  public async handleCreateGroup(): Promise<void> {
    await this.handleResetBusinessRules();
    this.handleCurrentStep(1);
  }
  public handleCancel(): void {
    if (this.groupFlow) {
      this.handleCurrentStep(0);
      this.handleResetCreateGroup();
    } else {
      this.handleCurrentStep(2);
      this.handleRuleName("");
    }
  }
  public handleAddRule(): void {
    this.handleCurrentStep(3);
  }
  public async handleCreateNext(): Promise<void> {
    this.nextLoading = true;
    if (this.groupFlow) {
      const createGroupPayload = {
        name: this.businessRules.createGroup!.name,
        description: this.businessRules.createGroup!.description
      };
      await this.createGroup(createGroupPayload);
      this.handleCurrentStep(2);
    } else {
      await this.createNewCondition();
      this.handleCurrentStep(4);
    }
    this.nextLoading = false;
  }

  // ===== Computed ===== //
  get currentStep(): number {
    return this.businessRules.currentStep;
  }
  get description(): string {
    return this.businessRules.createGroup!.description ? this.businessRules.createGroup!.description : "";
  }
  set description(newVal: string) {
    this.handleGroupDescription(newVal);
  }
  get groupFlow(): boolean {
    return this.flow === "group";
  }
  get groupFlowNext(): boolean {
    return !!(this.name && this.description);
  }
  get name(): string {
    return this.groupFlow ? this.businessRules.createGroup!.name : this.businessRules.ruleName;
  }
  set name(newVal: string) {
    this.groupFlow ? this.handleGroupName(newVal) : this.handleRuleName(newVal);
  }
  get rulesFlow(): boolean {
    return this.flow === "rules";
  }
}

